/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateSerieVideoLangRequestViewModel } from "../types/UpdateSerieVideoLangRequestViewModel.ts";

export const updateSerieVideoLangRequestViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  title: z.string().describe("Título do vídeo neste idioma.").nullish(),
  resumee: z
    .string()
    .describe("Resumo do vídeo neste idioma. Opcional.")
    .nullish(),
  embed: z.string().describe("HTML/embed do vídeo neste idioma.").nullish(),
}) as unknown as ToZod<UpdateSerieVideoLangRequestViewModel>;
